import React, { useState } from "react";
import { Link } from "react-router-dom";
import SriLanka from "./sri_lanka";
import Bangladesh from "./bangladesh";
import Vietnam from "./vietnam";
import Ethiopia from "./ethiopia";
import Group from "./group";
import "./equality-chart-2.css";

export default function Highlights() {
  const [selectedTab, setSelectedTab] = useState("srilanka");

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const handleKeyDown = (e, tab) => {
    if (e.key === "Enter" || e.key === " ") {
      setSelectedTab(tab);
    }
  };

  const renderPage = () => {
    switch (selectedTab) {
      case "srilanka":
        return <SriLanka />;
      case "banglades":
        return <Bangladesh />;
      case "vietnam":
        return <Vietnam />;
      case "ethiopia":
        return <Ethiopia />;
      case "group":
        return <Group />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div>
        <h4 className="main-topic-chart-p empower-equality-chart-03">
          % of supervisory positions held by women
        </h4>
        <br />
        <div className="chart-1-paragraph-two-column empower-equality-chart-03">
          <div className="chart-1-paragraph-column-1">
            <center>
              <h1 className="topic-chart-p empower-equality-chart-03">Country</h1>
            </center>
          </div>
          <div className="chart-1-paragraph-column-2">
            <div className="e-pc empower-equality-chart-03">
              <div className="main-circles empower-equality-chart-03">
                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "srilanka" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("srilanka")}
                  onKeyDown={(e) => handleKeyDown(e, "srilanka")}
                >
                  {/* <img src={srilanka} alt="1" /> */}
                  <h3 className={selectedTab === "srilanka" ? "selected" : ""}>
                    Sri Lanka
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "banglades" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("banglades")}
                  onKeyDown={(e) => handleKeyDown(e, "banglades")}
                >
                  {/* <img src={banglades} alt="2" /> */}
                  <h3 className={selectedTab === "banglades" ? "selected" : ""}>
                    Bangladesh
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "vietnam" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("vietnam")}
                  onKeyDown={(e) => handleKeyDown(e, "vietnam")}
                >
                  {/* <img src={vietnam} alt="3" /> */}
                  <h3 className={selectedTab === "vietnam" ? "selected" : ""}>
                    Vietnam
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "ethiopia" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("ethiopia")}
                  onKeyDown={(e) => handleKeyDown(e, "ethiopia")}
                >
                  {/* <img src={ethiopia} alt="4" /> */}
                  <h3 className={selectedTab === "ethiopia" ? "selected" : ""}>
                    Ethiopia
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "group" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("group")}
                  onKeyDown={(e) => handleKeyDown(e, "group")}
                >
                  {/* <img src={group_2} alt="5" /> */}
                  <h3 className={selectedTab === "group" ? "selected" : ""}>
                    H-Group
                  </h3>
                </Link>
              </div>
            </div>

            <div className="e-mobile empower-equality-chart-03">
              <div className="main-circles empower-equality-chart-03">
                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "srilanka" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("srilanka")}
                  onKeyDown={(e) => handleKeyDown(e, "srilanka")}
                >
                  {/* <img src={srilanka} alt="1" /> */}
                  <h3 className={selectedTab === "srilanka" ? "selected" : ""}>
                    Sri Lanka
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "banglades" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("banglades")}
                  onKeyDown={(e) => handleKeyDown(e, "banglades")}
                >
                  {/* <img src={banglades} alt="2" /> */}
                  <h3 className={selectedTab === "banglades" ? "selected" : ""}>
                    Bangladesh
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "vietnam" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("vietnam")}
                  onKeyDown={(e) => handleKeyDown(e, "vietnam")}
                >
                  {/* <img src={vietnam} alt="3" /> */}
                  <h3 className={selectedTab === "vietnam" ? "selected" : ""}>
                    Vietnam
                  </h3>
                </Link>
              </div>

              <div className="main-circles empower-equality-chart-03">
                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "ethiopia" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("ethiopia")}
                  onKeyDown={(e) => handleKeyDown(e, "ethiopia")}
                >
                  {/* <img src={ethiopia} alt="4" /> */}
                  <h3 className={selectedTab === "ethiopia" ? "selected" : ""}>
                    Ethiopia
                  </h3>
                </Link>

                <Link
                  tabIndex={0}
                  className={`chart-circle ${
                    selectedTab === "group" ? "selected" : ""
                  }`}
                  onClick={() => handleTabClick("group")}
                  onKeyDown={(e) => handleKeyDown(e, "group")}
                >
                  {/* <img src={group_2} alt="5" /> */}
                  <h3 className={selectedTab === "group" ? "selected" : ""}>
                    H-Group
                  </h3>
                </Link>
              </div>
            </div>

            <br />
          </div>
        </div>

        <div className="equality-chart-1-renderpage">{renderPage()}</div>
      </div>
    </div>
  );
}
